"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/defineProperty"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _IconChevronUp = _interopRequireDefault(require("../../assets/icons/IconChevronUp"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["headerRef", "className"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
(function _() {
  var styles = ".ToTop {\n  position: relative;\n}\n.ToTop__box {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: #0a5ec0;\n  padding: 0.75rem;\n  position: fixed;\n  right: 1rem;\n  bottom: 1rem;\n  cursor: pointer;\n  border-radius: 0.25rem;\n  z-index: 9;\n  font-size: 1rem;\n}\n.ToTop__box__hide {\n  display: none;\n}";
  var fileName = "ToTop_ToTop";
  var element = document.querySelector("style[data-sass-component='ToTop_ToTop']");
  if (!element) {
    var styleBlock = document.createElement("style");
    styleBlock.innerHTML = styles;
    styleBlock.setAttribute("data-sass-component", fileName);
    document.head.appendChild(styleBlock);
  } else {
    element.innerHTML = styles;
  }
})();
var ToTop = function ToTop(_ref) {
  var headerRef = _ref.headerRef,
    _ref$className = _ref.className,
    className = _ref$className === void 0 ? '' : _ref$className,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    showElement = _useState2[0],
    setShowElement = _useState2[1];
  var goToTop = function goToTop(e) {
    if (e.type === 'click' || e.keyCode === 13) {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    }
  };
  (0, _react.useEffect)(function () {
    var headerHeight = headerRef.current && headerRef.current.clientHeight;
    document.addEventListener('scroll', function () {
      if (headerHeight) {
        setShowElement(!(window.scrollY <= headerHeight));
      }
    });
  }, [headerRef]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", _objectSpread(_objectSpread({
    className: "ToTop"
  }, rest), {}, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      role: "button",
      className: "ToTop__box ".concat(className, " ").concat(showElement ? '' : 'ToTop__box__hide'),
      onClick: goToTop,
      onKeyDown: goToTop,
      tabIndex: 0,
      "aria-label": "Scroll to Top",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_IconChevronUp["default"], {
        size: 16
      })
    })
  }));
};
var _default = ToTop;
exports["default"] = _default;